import { Project } from './project'

export default function (key: keyof typeof Project.flags) {
  return Project.flags[key]
}
